import script from "./vmsCustomAttributeManager.vue?vue&type=script&lang=js"
export * from "./vmsCustomAttributeManager.vue?vue&type=script&lang=js"

import "./vmsCustomAttributeManager.vue?vue&type=style&index=0&id=073713a4&lang=css"
import "./vmsCustomAttributeManager.vue?vue&type=style&index=1&id=073713a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073713a4"]])

export default __exports__